export default __webpack_public_path__ + "static/media/green.a361963b.jpg";